export const COMMUNITIES = "Communities";
export const COMMUNITY_LOCATIONS = "CommunityLocations";
export const CREATE_COMMUNITY = "CreateCommunity";
export const EDIT_COMMUNITY = "EditCommunity";
export const CORPORATIONS = "Corporations";
export const CREATE_CORPORATION = "CreateCorporation";
export const EDIT_CORPORATION = "EditCorporation";

export const TERMS = "Terms";
export const CART = "Cart";
export const FORGOT_PASSWORD = "ForgotPassword";
export const RESET_PASSWORD = "ResetPassword";
export const LOGIN = "Login";
export const REGISTER = "Register";

export const PRICING = "Pricing";
export const SETTINGS = "Settings";
export const EARLY_BIRD = "EarlyBird";
export const NOTIFICATION_SETTINGS = "NotificationSettings";

export const NEWSLETTERS = "Newsletters";
export const EDIT_NEWSLETTER = "EditNewsletter";
export const HOME = "Home";
export const DASHBOARD = "Dashboard";
export const ORDERS = "Orders";
export const ACCOUNT_DETAILS = "AccountDetails";
export const CHECKOUT = "Checkout";
export const SUSPENDED = "Suspended";

// calendars
export const CALENDARS = "Calendars";
export const CREATE_CALENDAR = "CreateCalendar";
export const EDIT_CALENDAR = "EditCalendar";

// orders
export const ORDER_DASHBOARD = "OrderDashboard";
export const PENDING_ORDERS = "PendingOrders";
export const ORDER_HUB = "OrderHub";
export const CLOSED_ORDERS = "ClosedOrders";
export const VIEW_ORDER = "ViewOrder";
export const EDIT_ORDER = "EditOrder";
export const EDIT_ORDER_STATUS = "EditOrderStatus";
export const EDIT_ORDER_INVOICE_LINES = "EditInvoiceLines";

// filler articles
export const FILLER_ARTICLES = "FillerArticles";
export const CREATE_FILLER_ARTICLE = "CreateFillerArticle";
export const EDIT_FILLER_ARTICLE = "EditFillerArticle";

export const USERS = "Users";
export const THEMES = "Themes";

export const SAGE = "Sage";

export const ANNOUNCEMENTS = "Announcements";

export const HOLIDAY = "Holiday";

export const EVENT_LOGS = "EventLogs";

export const DIGITAL_DISPLAY = "DigitalDisplay";

export const DIGITAL_DISPLAY_URL = "DigitalDisplayUrl";
export const COMMUNITY_LOGS = "CommunityLogs";
export const NEWS_PROOFS = "NewsProofs";

export const ACCESS_DENIED = "AccessDenied";
export const ERROR_PAGE = "ErrorPage";
